/**
 * Transform calculator state to API format for PDF generation
 * @param {Array} investmentCalculators - Array of calculator objects from GlobalContext
 * @param {string} language - Current language ('en' or 'mk')
 * @returns {Object} Formatted data for API
 */
export function mapCalculatorDataForAPI(investmentCalculators, language) {
  // Filter only selected investments
  const selectedInvestments = investmentCalculators.filter((calc) => calc.selected);

  // Map to API format
  const investments = selectedInvestments.map((calc) => ({
    name: calc.name || undefined,
    initialInvestment: calc.initialInvestment,
    regularAddition: calc.regularAddition,
    interestRate: calc.interestRate,
    additionPeriod: calc.additionPeriod,
    termInYears: calc.termInYears,
    interestCompoundedType: calc.interestCompoundedType,
  }));

  return {
    language: language || 'en',
    investments,
  };
}
